export default __webpack_public_path__ + "static/media/Wicungo2.f698892f.jpeg";